import React from "react";
import ReactDOM from "react-dom";
// import registerServiceWorker from "./registerServiceWorker";
import AppRouter from "./app-router";

ReactDOM.render(<AppRouter />, document.getElementById("root"));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js